const manager = {
  "Admin": {
    actions: []
  },
  "Content": {
    actions: []
  },
  "Dashboard": {
    actions: ['view']
  },
  "Help": {
    actions: []
  },
  "Inbox": {
    actions: []
  },
  "Notifications": {
    actions: ['view']
  },
  "Objects": {
    actions: []
  },
  "Search": {
    actions: []
  },
  "Settings": {
    actions: []
  },
  "Support": {
    actions: []
  },
  "Tasks": {
    actions: []
  },
  "Teams": {
    actions: []
  },
  "Profile.PersonalInformation": {
    actions: ['view', 'edit']
  },
  "Profile.Password": {
    actions: ['view', 'edit']
  },
  "Profile.Notifications": {
    actions: []
  },
  "Profile.Security": {
    actions: []
  },
  "Profile.Log": {
    actions: []
  },
  "Modules.Customer": {
    actions: ['view', 'edit', 'create']
  },
  "Modules.Customer.Contacts": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Customer.Comments": {
    actions: ['view', 'edit', 'create']
  },
  "Modules.Customer.Responsibles": {
    actions: ['view', 'edit', 'create']
  },
  "Modules.Customer.Address": {
    actions: ['view', 'edit', 'create']
  },
  "Modules.Customer.Station": {
    actions: ['view', 'edit', 'create']
  },
  "Modules.Customer.TechnicalInformation": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Gps": {
    actions: ['view', 'edit', 'create']
  },
  "Modules.Inspection": {
    actions: ['view', 'edit:own', 'create', 'delete:own']
  },
  "Modules.PeriodicCheck": {
    actions: ['view']
  },
  "Modules.Responsible": {
    actions: ['view', 'edit', 'create']
  },
  'Modules.Responsible.Comments': {
    actions: ['view', 'edit', 'create']
  },
  'Modules.Responsible.Contacts': {
    actions: ['view', 'edit', 'create']
  },
  'Modules.Responsible.Information': {
    actions: ['view', 'edit', 'create']
  },
  'Modules.Support': {
    actions: []
  },
  'MainMenu.Home': {
    actions: ['view']
  },
  'MainMenu.WorkManagement': {
    actions: ['view']
  },
  'MainMenu.Notifications': {
    actions: ['view']
  },
  'MainMenu.Inbox': {
    actions: []
  },
  'MainMenu.Tasks': {
    actions: []
  },
  'MainMenu.Support': {
    actions: []
  },
  'SubMenu.Help': {
    actions: []
  },
  'SubMenu.Search': {
    actions: []
  },
  'ProfileMenu.MyProfile': {
    actions: ['view']
  },
  'ProfileMenu.Admin': {
    actions: []
  },
  'ProfileMenu.Content': {
    actions: []
  },
  'ProfileMenu.Objects': {
    actions: []
  },
  'ProfileMenu.Teams': {
    actions: []
  },
  'ProfileMenu.SignOut': {
    actions: ['view']
  },
  'AdminMenu.General': {
    actions: []
  },
  'AdminMenu.Customization': {
    actions: []
  },
  'AdminMenu.User': {
    actions: []
  },
  'AdminMenu.Security': {
    actions: []
  },
  'AdminMenu.Permissions': {
    actions: []
  },
  'AdminMenu.Database': {
    actions: []
  },
  'AdminMenu.Reports': {
    actions: []
  },
  'AdminMenu.Enargas': {
    actions: []
  },
}

export default manager